import React from 'react';
import { Switch } from 'react-router-dom';

/** IMPORT PAGES */
import AtendimentoPosto from '~/pages/AtendimentoPosto';
import OperacaoRadAdmDadosFaturamentoSeplag from '~/pages/operacao/OperacaoRadAdmDadosFaturamentoSeplag';
import Arqueacao from '~/pages/Arqueacao';
import Bico from '~/pages/Bico';

/** IMPORT PAGES CADASTRO */

/** IMPORT PAGES CONFIGURAÇÃO */
import Auditoria from '~/pages/cadastros/Auditoria';
/** IMPORT PAGES OPERACAO */

import OperacaoAlterarSenha from '~/pages/operacao/OperacaoAlterarSenha';
import OperacaoAfericaoVeiculo from '~/pages/operacao/OperacaoAfericaoVeiculo';
import OperacaoLiberacaoRemotaConsulta from '~/pages/operacao/OperacaoLiberacaoRemotaConsulta';
import OperacaoRadPesquisaPreFaturaGfo from '~/pages/operacao/OperacaoRadPesquisaPreFaturaGfo';
import OperacaoRadPesquisaPreFaturaGfe from '~/pages/operacao/OperacaoRadPesquisaPreFaturaGfe';
import OperacaoRadPesquisaPreFaturaUnidata from '~/pages/operacao/OperacaoRadPesquisaPreFaturaUnidata';
import OperacaoBloqueioVeiculoPreFaturas from '~/pages/operacao/OperacaoBloqueioVeiculoPreFaturas';
import OperacaoBloqueioVeiculoPreFaturaGerada from '~/pages/operacao/OperacaoBloqueioVeiculoPreFaturaGerada';
import OperacaoTurno from '~/pages/operacao/OperacaoTurno';
import OperacaoRadAdmDadosFaturamentoUnidata from '~/pages/operacao/OperacaoRadAdmDadosFaturamentoUnidata';
import MonitoramentoAlertas from '~/pages/operacao/MonitoramentoAlertas';
import MonitoramentoAlertasFullScreen from '~/pages/operacao/MonitoramentoAlertas/fullscreen';
import EstoqueProduto from '~/pages/operacao/EstoqueProduto';

import OperacaoDiagnostico from '~/pages/operacao/OperacaoDiagnostico';

import OperacaoRadRelatorioPesquisaPreFaturaUnidata from '~/pages/operacao/OperacaoRadRelatorioPesquisaPreFaturaUnidata';

import OperacaoRadPreFaturaBloqueioPlacaRelatorio from '~/pages/operacao/OperacaoRadPreFaturaBloqueioPlacaRelatorio';

import OperacaoVeiculoManutencaoUnidata from '~/pages/operacao/OperacaoVeiculoManutencaoUnidata';

import OperacaoPleitoPosto from '~/pages/operacao/OperacaoPleitoPosto';
import OperacaoCotaDistribOrgao from '~/pages/operacao/OperacaoCotaDistribOrgao';
import OperacaoCotaDistribUnidade from '~/pages/operacao/OperacaoCotaDistribUnidade';
import OperacaoCotaDistribVeiculo from '~/pages/operacao/OperacaoCotaDistribVeiculo';

import OperacaoPleitoVeiculo from '~/pages/operacao/OperacaoPleitoVeiculo';

/** IMPORT PAGES OPERACAO */

import CadastroCondutor from '~/pages/cadastros/CadastroCondutor';
import CadastroMarca from '~/pages/cadastros/CadastroMarca';
import CadastroPosto from '~/pages/cadastros/CadastroPosto';
import CadastroTerminal from '~/pages/cadastros/CadastroTerminal';
import CadastroMedidor from '~/pages/cadastros/CadastroMedidor';
import CadastroTanqueVirtual from '~/pages/cadastros/CadastroTanqueVirtual';
import CadastroTanqueFisico from '~/pages/cadastros/CadastroTanqueFisico';
import Frentista from '~/pages/cadastros/Frentista';
import Orgao from '~/pages/cadastros/Orgao';
import PostoPlanejamento from '~/pages/cadastros/PostoPlanejamento';
import Unidade from '~/pages/cadastros/Unidade';
import Usuario from '~/pages/cadastros/Usuario';
import Veiculo from '~/pages/cadastros/Veiculo';
import Dashboard from '~/pages/Dashboard';
import NotFound from '~/pages/errors/NotFound';

// /** IMPORT PAGES RELATORIOS */
import SaldoCombustivelPostoPeriodo from '~/pages/relatorios/SaldoCombustivelPostoPeriodo';
import SaldoCombustivelPostoPeriodoTanque from '~/pages/relatorios/SaldoCombustivelPostoPeriodoTanque';
import EstoqueOrgao from '~/pages/relatorios/EstoqueOrgao';
import EstoquePosto from '~/pages/relatorios/EstoquePosto';
import AbastecimentoContigenciaLista from '~/pages/relatorios/AbastecimentoContigenciaLista';
import Relabastecimento from '~/pages/relatorios/Relabastecimento';
import EsqueciMinhaSenha from '~/pages/EsqueciMinhaSenha';
import AuditoriaParametros from '~/pages/operacao/AuditoriaParametros';
import InicializacaoCota from '~/pages/operacao/InicializacaoCota';
import LimiteAbastecimento from '~/pages/operacao/LimiteAbastecimento';
import OperacaoAbastecimento from '~/pages/operacao/OperacaoAbastecimento';
import OperacaoAlinhamento from '~/pages/operacao/OperacaoAlinhamento';
import OperacaoConsultaImpedimentos from '~/pages/operacao/OperacaoConsultaImpedimentos';
import OperacaoConsultaLogLiberacaoSiad from '~/pages/operacao/OperacaoConsultaLogLiberacaoSiad';
import OperacaoExtratoDadosCapaTnqPostos from '~/pages/operacao/OperacaoExtratoDadosCapaTnqPostos';
import OperacaoImpedimentos from '~/pages/operacao/OperacaoImpedimentos';
import OperacaoLiberacaoRemota from '~/pages/operacao/OperacaoLiberacaoRemota';
import OperacaoNotaFiscalDescargas from '~/pages/operacao/OperacaoNotaFiscalDescargas';
import OperacaoOperStatusTerminais from '~/pages/operacao/OperacaoOperStatusTerminais';
import OperacaoPostoControleSiad from '~/pages/operacao/OperacaoPostoControleSiad';
import OperacaoPostoManutencao from '~/pages/operacao/OperacaoPostoManutencao';
import OperacaoPostoMigraGestoresFrentista from '~/pages/operacao/OperacaoPostoMigraGestoresFrentista';
import OperacaoPreRecebimento from '~/pages/operacao/OperacaoPreRecebimento';
import OperacaoPreRecebimentoLista from '~/pages/operacao/OperacaoPreRecebimentoLista';
import OperacaoRadAprovarPreFatura from '~/pages/operacao/OperacaoRadAprovarPreFatura';
import OperacaoRecebimento from '~/pages/operacao/OperacaoRecebimento';
import OperacaoVazamento from '~/pages/operacao/OperacaoVazamento';
import Rateio from '~/pages/operacao/Rateio';
import SaldoCotaOrgaoLista from '~/pages/operacao/SaldoCotaOrgaoLista';
import TurnoAcompanhamento from '~/pages/operacao/TurnoAcompanhamento';
import UnidadeSaldoCota from '~/pages/operacao/UnidadeSaldoCota';
import Perfil from '~/pages/Perfil';
import Produto from '~/pages/Produto';
import Relabastecimentodoorgaonoperiodo from '~/pages/relatorios/Relabastecimentodoorgaonoperiodo';
import Relabastecimentonoperiododata from '~/pages/relatorios/Relabastecimentonoperiododata';
import Relabastecimentonoperiodovalor from '~/pages/relatorios/Relabastecimentonoperiodovalor';
import Relabastecimentonoposto from '~/pages/relatorios/Relabastecimentonoposto';
import Relabastecimentopartidafrio from '~/pages/relatorios/Relabastecimentopartidafrio';
import Relabastecimentosdoveiculooficial from '~/pages/relatorios/Relabastecimentosdoveiculooficial/index';
import Relabastecimentosnoperiodovolume from '~/pages/relatorios/Relabastecimentosnoperiodovolume';
import Relanaliticodadespesa from '~/pages/relatorios/Relanaliticodadespesa';
import Relaquisicaocombustiveldadosentradanf from '~/pages/relatorios/Relaquisicaocombustiveldadosentradanf';
import Relaquisicaocombustivelorgaonfentradas from '~/pages/relatorios/Relaquisicaocombustivelorgaonfentradas';
import Relatorioprerecebimentocombpostoperiodo from '~/pages/relatorios/Relatorioprerecebimentocombpostoperiodo';
import Relconsumocombustivelorgaoperiodounidade from '~/pages/relatorios/Relconsumocombustivelorgaoperiodounidade';
import Relconsumocombustivelperiodo from '~/pages/relatorios/Relconsumocombustivelperiodo';
import Relconsumocombustivelunidadeperiododata from '~/pages/relatorios/Relconsumocombustivelunidadeperiododata';
import Relconsumocombustivelunidadeperiodoveiculos from '~/pages/relatorios/Relconsumocombustivelunidadeperiodoveiculos';
import Reldadosabastecimentoveiculo from '~/pages/relatorios/Reldadosabastecimentoveiculo';
import RelDadosTurnosPostoPeriodoTanque from '~/pages/relatorios/RelDadosTurnosPostoPeriodoTanque';
import Reldespesaaquisicaocombustivel from '~/pages/relatorios/Reldespesaaquisicaocombustivel';
import Reldespesaaquisicaocombustivelorgao from '~/pages/relatorios/Reldespesaaquisicaocombustivelorgao';
import Relextratoproduto from '~/pages/relatorios/Relextratoproduto';
import Rellistagemimpedimento from '~/pages/relatorios/Rellistagemimpedimento';
import Reloperstatusterminais from '~/pages/relatorios/Reloperstatusterminais';
import Relrecebimento from '~/pages/relatorios/Relrecebimento';
import Relrecebimentocombpostoperiodoprodutonf from '~/pages/relatorios/Relrecebimentocombpostoperiodoprodutonf';
import Relrecebimentocombustivelpostoperiodo from '~/pages/relatorios/Relrecebimentocombustivelpostoperiodo';
import Relresumooperacao from '~/pages/relatorios/Relresumooperacao';
import Relresumoturno from '~/pages/relatorios/Relresumoturno';
import Relvazaonaoautorizada from '~/pages/relatorios/Relvazaonaoautorizada';
import Relvazaonaoautorizadaperiodo from '~/pages/relatorios/Relvazaonaoautorizadaperiodo';
import Relvazaonaoautorizadapostosperiodo from '~/pages/relatorios/Relvazaonaoautorizadapostosperiodo';

import SaldoCombustivelPostosData from '~/pages/relatorios/SaldoCombustivelNosPostosData';
import Route from './Route';
import SaldoCombustivelNosPostosDataPostos from '~/pages/relatorios/SaldoCombustivelNosPostosDataPostos';
import SaldoContabilCombustivelOrgao from '~/pages/relatorios/SaldoContabilCombustivelOrgao';

import Relinstrumentomedicaoresultado from '~/pages/relatorios/Relinstrumentomedicaoresultado';
import Relquantitativoveiculosvalortotal from '~/pages/relatorios/Relquantitativoveiculosvalortotal';

import RelatorioVeiculosInstQueNaoAbasteceram from '~/pages/RelatorioVeiculosInstQueNaoAbasteceram';
import RelatorioAbastecimentoSeplag from '~/pages/RelatorioAbastecimentoSeplag';





import SignIn from '~/pages/SignIn';
import SignOut from '~/pages/SignOut';

export default function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />


      <Route
        path="/relatorioabastecimentosseplag"
        component={RelatorioAbastecimentoSeplag}
        title="Relatório Veículos que Abasteceram"
        isPrivate
        exact
      />

      <Route
        path="/veicinstaladosquenaoabasteceram"
        component={RelatorioVeiculosInstQueNaoAbasteceram}
        title="Relatório Veículos Inst. Que Não Abasteceram"
        isPrivate
        exact
      />


      <Route
        path="/atendimentoposto"
        component={AtendimentoPosto}
        title="Atendimento Posto"
        isPrivate
        exact
      />
      <Route
        path="/monitoramento_alertas"
        component={MonitoramentoAlertas}
        title="Monitoramento Alertas"
        isPrivate
        exact
      />

      <Route
        path="/monitoramento_alertas_fullscreen"
        component={MonitoramentoAlertasFullScreen}
        title="Monitoramento Alertas"
        isPrivate
        fullScreen
        exact
      />

      <Route
        path="/rel.1.1.4.1"
        component={SaldoCombustivelNosPostosDataPostos}
        title="Saldo Combustível nos Postos na Data - Postos"
        isPrivate
        exact
      />

      <Route
        path="/rel.1.2.3.1"
        component={SaldoContabilCombustivelOrgao}
        title="Saldo Contábil Combustível do Órgão - Período"
        isPrivate
        exact
      />

      <Route
        path="/rel_instrumento_medicao_resultado"
        component={Relinstrumentomedicaoresultado}
        title="Relatório instrumento de medição de resultado"
        isPrivate
        exact
      />

      <Route
        path="/relquantitativoveiculosvalortotal"
        component={Relquantitativoveiculosvalortotal}
        title="Relatório Quantitativo veículos e valor total"
        isPrivate
        exact
      />

      <Route
        path="/relestoqueorgao"
        component={EstoqueOrgao}
        title="Estoque"
        isPrivate
        exact
      />

      <Route
        path="/relestoqueposto"
        component={EstoquePosto}
        title="Estoque Posto"
        isPrivate
        exact
      />

      <Route
        path="/cadunidadesaldocota"
        component={UnidadeSaldoCota}
        title="Unidade Saldo/Cota"
        isPrivate
        exact
      />

      <Route
        path="/saldocotaorgaolista"
        component={SaldoCotaOrgaoLista}
        title="Saldo Cota Orgao Lista"
        isPrivate
        exact
      />

      <Route
        path="/grideauditoriaparametros"
        component={AuditoriaParametros}
        title="Auditoria Parametros"
        isPrivate
        exact
      />

      <Route path="/perfil" component={Perfil} title="Perfil" isPrivate exact />

      <Route
        path="/arqueacao"
        component={Arqueacao}
        title="Arqueações"
        isPrivate
        exact
      />

      <Route
        path="/produto"
        component={Produto}
        title="Produtos"
        isPrivate
        exact
      />

      <Route path="/bico" component={Bico} title="Bicos" isPrivate exact />

      <Route
        path="/relabastecimentocontigencia"
        component={AbastecimentoContigenciaLista}
        title="Abastecimento Contigência Lista"
        isPrivate
        exact
      />

      <Route path="/EsqueciMinhaSenha" exact component={EsqueciMinhaSenha} />

      <Route path="/dashboard" component={Dashboard} title="" isPrivate />

      <Route
        path="/abastecimento"
        component={OperacaoAbastecimento}
        title="Abastecimentos"
        isPrivate
      />

      <Route
        path="/liberacaoremota"
        component={OperacaoLiberacaoRemota}
        title="Liberação Remota"
        isPrivate
      />

      <Route
        path="/notafiscaldescargas"
        component={OperacaoNotaFiscalDescargas}
        title="Status Notas Fiscais"
        isPrivate
      />

      <Route
        path="/prerecebimentolista"
        component={OperacaoPreRecebimentoLista}
        title="Recebimento Provisório Lista"
        isPrivate
      />

      <Route
        path="/consultalogliberacaosiad"
        component={OperacaoConsultaLogLiberacaoSiad}
        title="Consulta Liberação Interface SIAD"
        isPrivate
      />

      <Route
        path="/consultaimpedimentos"
        component={OperacaoConsultaImpedimentos}
        title="Consulta Impedimentos"
        isPrivate
      />

      <Route
        path="/extradadoscapatnqpostos"
        component={OperacaoExtratoDadosCapaTnqPostos}
        title="Capacidade Tanques Postos"
        isPrivate
      />

      <Route
        path="/radprefaturabloqueioplaca"
        component={OperacaoBloqueioVeiculoPreFaturaGerada}
        title="Bloqueio Veículo Pré-fatura Gerada"
        isPrivate
      />

      <Route
        path="/postocontrolesiad"
        component={OperacaoPostoControleSiad}
        title="Posto Interface SIAD"
        isPrivate
      />

      <Route
        path="/postomanutencao"
        component={OperacaoPostoManutencao}
        title="Posto Manutenção"
        isPrivate
      />

      <Route
        path="/postomigragestoresfrentista"
        component={OperacaoPostoMigraGestoresFrentista}
        title="Posto Migra Gestores Frentista"
        isPrivate
      />

      <Route
        path="/vazamento"
        component={OperacaoVazamento}
        title="Vazão não autorizada"
        isPrivate
      />

      <Route
        path="/operstatusterminais"
        component={OperacaoOperStatusTerminais}
        title="Status Terminais"
        isPrivate
      />

      <Route
        path="/relabastecimento"
        component={Relabastecimento}
        title="s.menu.relatorio.abastecimentocontingencia"
        isPrivate
        exact
      />

      <Route
        path="/relabastecimentopartidafrio"
        component={Relabastecimentopartidafrio}
        title="Abastecimentos Partida a Frio"
        isPrivate
        exact
      />

      <Route
        path="/relvazamento"
        component={Relvazaonaoautorizada}
        title="Vazão não autorizada"
        isPrivate
      />

      <Route
        path="/reldescarga"
        component={Relrecebimento}
        title="Descarga"
        isPrivate
        exact
      />

      <Route
        path="/relextratoproduto"
        component={Relextratoproduto}
        title="Extrato de Produto"
        isPrivate
        exact
      />

      <Route
        path="/rellistagemimpedimento"
        component={Rellistagemimpedimento}
        title="Listagem de impedimentos"
        isPrivate
        exact
      />

      <Route
        path="/rel.2.2.3.1"
        component={Relabastecimentonoposto}
        title="Abastecimentos no posto"
        isPrivate
        exact
      />

      <Route
        path="/rel.3.1_orgao_analitico_despesa"
        component={Relanaliticodadespesa}
        title="Relatório Analítico da Despesa"
        isPrivate
        exact
      />

      <Route
        path="/relresumooperacao"
        component={Relresumooperacao}
        title="Resumo Operação"
        isPrivate
        exact
      />

      <Route
        path="/recebimentocombpostoperiodoprodutonf"
        component={Relrecebimentocombpostoperiodoprodutonf}
        title="Recebimento Informação Produto NF"
        isPrivate
        exact
      />

      <Route
        path="/rel.2.1.1.1"
        component={Relabastecimentosdoveiculooficial}
        title="Abastecimentos do Veículo Oficial"
        isPrivate
        exact
      />

      <Route
        path="/relabastorgaoperiodovolume"
        component={Relabastecimentodoorgaonoperiodo}
        title="Abastecimentos do Órgão no Período - Volume"
        isPrivate
        exact
      />

      <Route
        path="/rel.1.3.1.2"
        component={Relabastecimentonoperiodovalor}
        title="Abastecimento da Unidade no Período - Valor"
        isPrivate
        exact
      />
      <Route
        path="/prerecebimento"
        component={OperacaoPreRecebimento}
        title="Recebimento Provisório"
        isPrivate
        exact
      />

      <Route
        path="/rel.1.2.2.3"
        component={Relabastecimentonoperiododata}
        title="s.menu.relatorio.abastecimentonoperiododata"
        isPrivate
        exact
      />

      <Route
        path="/rel.1.2.2.2"
        component={Relconsumocombustivelorgaoperiodounidade}
        title="Consumo Combustível Órgão Período - Unidades"
        isPrivate
        exact
      />
      <Route
        path="/relresumoturno"
        component={Relresumoturno}
        title="Relatório de Resumo de Turno"
        isPrivate
        exact
      />

      <Route
        path="/reloperstatusterminais"
        component={Reloperstatusterminais}
        title="Status de Comunicação dos Terminais"
        isPrivate
        exact
      />

      <Route
        path="/relconsumocombustivelperiodo"
        component={Relconsumocombustivelperiodo}
        title="Consumo Combustível Por Período"
        isPrivate
        exact
      />

      <Route
        path="/relaquisicaocombustivelorgaonfentrada"
        component={Relaquisicaocombustivelorgaonfentradas}
        title="Aquisição Combustível Órgão – NF Entradas"
        isPrivate
        exact
      />

      <Route
        path="/rel.1.3.1.1"
        component={Relabastecimentosnoperiodovolume}
        title="Abastecimentos no Período – Volume"
        isPrivate
        exact
      />

      <Route
        path="/reldespesaaquisicaocombustivelorgao"
        component={Reldespesaaquisicaocombustivelorgao}
        title="Despesa Aquisição Combustível - Órgão"
        isPrivate
        exact
      />

      <Route
        path="/rel.2.1.1.2"
        component={Reldadosabastecimentoveiculo}
        title="Dados do Abastecimento do Veículo"
        isPrivate
        exact
      />

      <Route
        path="/rel.1.3.1.4"
        component={Relconsumocombustivelunidadeperiododata}
        title="Consumo Combustível Unidade no Período – Data"
        isPrivate
        exact
      />

      <Route
        path="/relaquisicaocombustiveldadosentradanf"
        component={Relaquisicaocombustiveldadosentradanf}
        title="Aquisição de Combustível – Dados da Entrada NF"
        isPrivate
        exact
      />

      <Route
        path="/reldespesaaquisicaocombustivel"
        component={Reldespesaaquisicaocombustivel}
        title="Despesa com Aquisição de Combustível"
        isPrivate
        exact
      />

      <Route
        path="/descarga"
        component={OperacaoRecebimento}
        title="Recebimento"
        isPrivate
        exact
      />

      <Route
        path="/rel.1.3.1.3"
        component={Relconsumocombustivelunidadeperiodoveiculos}
        title="Consumo de Combustível da Unidade no Período - Veículos"
        isPrivate
        exact
      />

      <Route
        path="/rel.2.2.2.1"
        component={Relrecebimentocombustivelpostoperiodo}
        title="Recebimentos Combustível Postos no Período"
        isPrivate
        exact
      />

      <Route
        path="/impedimento"
        component={OperacaoImpedimentos}
        title="Impedimentos"
        isPrivate
        exact
      />

      <Route
        path="/radaprovarprefatura"
        component={OperacaoRadAprovarPreFatura}
        title="Aprovar Pré-fatura"
        isPrivate
        exact
      />

      <Route
        path="/consultaliberacaoremota"
        component={OperacaoLiberacaoRemotaConsulta}
        title="Liberação Remota - Consulta"
        isPrivate
        exact
      />
      <Route
        path="/veiculomanutencaoafericao"
        component={OperacaoAfericaoVeiculo}
        title="Aferição de Veículo"
        isPrivate
        exact
      />

      <Route
        path="/alinhamento"
        component={OperacaoAlinhamento}
        title="Alinhamentos"
        isPrivate
        exact
      />

      <Route
        path="/altsenha"
        component={OperacaoAlterarSenha}
        title="Alterar Senha"
        isPrivate
        exact
      />

      <Route
        path="/radpesquisaprefaturagfo"
        component={OperacaoRadPesquisaPreFaturaGfo}
        title="Pesquisar Pré-fatura"
        isPrivate
        exact
      />

      <Route
        path="/radpesquisaprefaturagfe"
        component={OperacaoRadPesquisaPreFaturaGfe}
        title="Pesquisar Pré-fatura"
        isPrivate
        exact
      />
      <Route
        path="/radpesquisaprefaturaunidata"
        component={OperacaoRadPesquisaPreFaturaUnidata}
        title="Pesquisar Pré-fatura"
        isPrivate
        exact
      />

      <Route
        path="/veiculobloqueiofaturamento"
        component={OperacaoBloqueioVeiculoPreFaturas}
        title="Bloqueio Veículo Pré-Fatura"
        isPrivate
        exact
      />

      <Route
        path="/cadfrentista"
        component={Frentista}
        title="Cadastro de Frentistas"
        isPrivate
        exact
      />

      <Route
        path="/cadfrentistanovo"
        component={Frentista}
        title="Cadastro de Frentistas novo"
        isPrivate
        exact
      />

      <Route
        path="/usuariomaster"
        component={Usuario}
        title="Usuários"
        isPrivate
        exact
      />

      <Route
        path="/usuariomasternovo"
        component={Usuario}
        title="Usuários Novo"
        isPrivate
        exact
      />

      <Route
        path="/cadorgao"
        component={Orgao}
        title="Cadastro de Órgão"
        isPrivate
        exact
      />

      <Route
        path="/estoque"
        component={EstoqueProduto}
        title="Estoques"
        isPrivate
        exact
      />

      <Route
        path="/turno"
        component={OperacaoTurno}
        title="Turnos"
        isPrivate
        exact
      />

      <Route
        path="/diagnostico"
        component={OperacaoDiagnostico}
        title="Diagnostico"
        isPrivate
        exact
      />

      <Route
        path="/cadcondutor"
        component={CadastroCondutor}
        title="Condutor"
        isPrivate
        exact
      />

      <Route
        path="/marca"
        component={CadastroMarca}
        title="Marcas"
        isPrivate
        exact
      />

      <Route
        path="/unidade"
        component={CadastroPosto}
        title="Postos"
        isPrivate
        exact
      />

      <Route
        path="/terminal"
        component={CadastroTerminal}
        title="Terminal"
        isPrivate
        exact
      />

      <Route
        path="/medidor"
        component={CadastroMedidor}
        title="Medidor"
        isPrivate
        exact
      />

      <Route
        path="/tanquevirtual"
        component={CadastroTanqueVirtual}
        title="Tanque Virtual"
        isPrivate
        exact
      />

      <Route
        path="/tanquefisico"
        component={CadastroTanqueFisico}
        title="Tanque Físico"
        isPrivate
        exact
      />

      <Route
        path="/radadmdadosfaturamentounidata"
        component={OperacaoRadAdmDadosFaturamentoUnidata}
        title="Inserir dados faturamento"
        isPrivate
        exact
      />

      <Route
        path="/veiculo"
        component={Veiculo}
        title="Veículo"
        isPrivate
        exact
      />

      <Route
        path="/cadunidade"
        component={Unidade}
        title="Unidade"
        isPrivate
        exact
      />

      <Route
        path="/postoplanejamentocliente"
        component={PostoPlanejamento}
        title="Posto Planejamento e Controle"
        isPrivate
        exact
      />

      <Route
        path="/radrelatoriopesquisaprefaturaunidata"
        component={OperacaoRadRelatorioPesquisaPreFaturaUnidata}
        title="Relatório Pré-fatura"
        isPrivate
        exact
      />

      <Route
        path="/radprefaturabloqueioplacarelatorio"
        component={OperacaoRadPreFaturaBloqueioPlacaRelatorio}
        title="Bloqueio Veículo Pré-fatura Relatório"
        isPrivate
        exact
      />

      <Route
        path="/veiculomanutencaounidata"
        component={OperacaoVeiculoManutencaoUnidata}
        title="Veículo Manutenção Abastek"
        isPrivate
        exact
      />
      <Route
        path="/relvazaonaoautorizadaperiodo"
        component={Relvazaonaoautorizadaperiodo}
        title="Vazão Não Autorizada do Posto no Período"
        isPrivate
        exact
      />

      <Route
        path="/relatorioprerecebimentocombpostoperiodo"
        component={Relatorioprerecebimentocombpostoperiodo}
        title="Recebimento Provisório combustível posto período"
        isPrivate
        exact
      />

      <Route
        path="/rel.1.1.4.2"
        component={SaldoCombustivelPostoPeriodo}
        title="Saldo de Combustível nos Posto no Período - Data"
        isPrivate
        exact
      />

      <Route
        path="/rel.2.2.4.1"
        component={SaldoCombustivelPostosData}
        title="Saldo de Combustível no Posto no Período - Data"
        isPrivate
        exact
      />

      <Route
        path="/rel.2.2.1.1"
        component={RelDadosTurnosPostoPeriodoTanque}
        title="Dados dos turnos do posto no período - Tanque"
        isPrivate
        exact
      />

      <Route
        path="/relvazaonaoautorizadapostosperiodo"
        component={Relvazaonaoautorizadapostosperiodo}
        title="Vazão Não Autorizada Postos"
        isPrivate
        exact
      />
      <Route
        path="/auditoria"
        component={Auditoria}
        title="Auditoria"
        isPrivate
        exact
      />

      <Route path="/rateio" component={Rateio} title="Rateio" isPrivate exact />

      <Route
        path="/resetcota"
        component={InicializacaoCota}
        title="Inicialização Cotas"
        isPrivate
        exact
      />

      <Route
        path="/cadacom_pleitoposto"
        component={OperacaoPleitoPosto}
        title="Pleito Posto"
        isPrivate
        exact
      />

      <Route
        path="/cadacom_pleitoveiculo"
        component={OperacaoPleitoVeiculo}
        title="Pleito Veículo"
        isPrivate
        exact
      />
      <Route
        path="/visuacotadistriborgao"
        component={OperacaoCotaDistribOrgao}
        title="Visualizar Cota Órgão"
        isPrivate
        exact
      />

      <Route
        path="/visuacotadistribunidade"
        component={OperacaoCotaDistribUnidade}
        title="Visualizar Cota Unidade"
        isPrivate
        exact
      />

      <Route
        path="/visuacotadistribveiculo"
        component={OperacaoCotaDistribVeiculo}
        title="Visualizar Cota Veículo"
        isPrivate
        exact
      />

      <Route
        path="/cadlimit_abastecim"
        component={LimiteAbastecimento}
        title="Limite de Abastecimento"
        isPrivate
        exact
      />

      <Route
        path="/statusturnoacompanhamento"
        component={TurnoAcompanhamento}
        title="Status Acompanhamento Turno"
        isPrivate
        exact
      />

      <Route
        path="/rad_gfe_adm_prefatura1"
        component={OperacaoRadAdmDadosFaturamentoUnidata}
        title=""
        isPrivate
        exact
      />


      <Route
        path="/rad_gfe_adm_prefatura"
        component={OperacaoRadAdmDadosFaturamentoSeplag}
        title="Rad GFE ADM Pré-fatura"
        isPrivate
        exact
      />

      <Route path="/sair" component={SignOut} title="Sair" isPrivate exact />

      {/*
        Não disponível para utilização.
        Não foi feito.
       <Route
        path="/rel.1.1.3.1"
        component={SaldoContabilCombustivelEstadoData}
        title="SALDO CONTÁBIL DE COMBUSTÍVEL DO ESTADO NA DATA - ÓRGÃOS/ ENTIDADES"
        isPrivate
        exact
      /> */}

      {/*
        Não disponível para utilização.
        Não foi feito.
       <Route
        path="/rel.1.1.3.2"
        component={.....}
        title="SALDO CONTÁBIL DE COMBUSTÍVEL DO ESTADO NO PERÍODO - DATA"
        isPrivate
        exact
      /> */}

      {/*
      <Route
        path="/relabastecimentocontingencia"
        component={Relabastecimentocontingencia}
        title="s.menu.relatorio.abastecimentocontingencia"
        isPrivate
        exact
      /> */}

      <Route path="*" component={NotFound} isPrivate />
    </Switch>
  );
}
